import React, { useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ShareIcon from '@material-ui/icons/Share';
import { makeStyles } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input';
import TextField from '@material-ui/core/TextField';
import { SubmitBtn } from '../submit-btn';
import { useApi } from '../../hooks';
import { useAlert } from '../alert-info/use-alert';
import * as Yup from 'yup';

const schema = Yup.object().shape({
  email: Yup.string().email(),
  comment: Yup.string(),
});

const useStyles = makeStyles(() => ({
  content: {
    overflowY: 'visible',
  },
  input: {
    minWidth: 200,
  },
  inputRoot: {
    flexWrap: 'wrap',
  },
}));

type ShareProps = {
  reportId: string;
  themeShortCode: string;
};

export const Share = ({ reportId, themeShortCode }: ShareProps) => {
  const [open, setOpen] = React.useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [emails, setEmails] = useState<string[]>([]);
  const [comments, setComment] = useState<string>('');
  
  const classes = useStyles();
  const { shareReport } = useApi();
  const { show, AlertTypes } = useAlert();

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setEmails([]);
    setOpen(false);
  }, []);

  const handleOnBeforeAdd = useCallback((email: string) => {
    try {
      schema.validateSync({ email });
      setInvalid(false);
      return true;
    } catch (error) {
      setInvalid(true);
      return false;
    }
  }, []);

  const handleOnChange = useCallback((emails: any[]) => {
    setEmails(emails);
  }, []);
  const handleOnChangeComment = useCallback((comments: string) => {
    setComment(comments);
  }, []);

  const handleOnShare = useCallback(async () => {
    try {
      setSubmitting(true);
      await shareReport({ emails, reportId, themeShortCode, comments });
      setSubmitting(false);
      show({ message: 'Le rapport a été partagé', severity: AlertTypes.success });
      handleClose();
    } catch (error) {
      setSubmitting(false);
      show({ message: 'impossible de partager le rapport', severity: AlertTypes.error });
    }
  }, [emails, reportId, themeShortCode, handleClose, show, AlertTypes, shareReport, comments]);

  return (
    <div>
      <Button color="primary" onClick={handleClickOpen} startIcon={<ShareIcon />}>
        Partager
      </Button>
      <Dialog open={open} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Partager</DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText>
            Pour partager le rapport , Merci d'entrer une adresses email et appuyer sur entrée.
          </DialogContentText>
          <ChipInput
            variant="outlined"
            defaultValue={[]}
            onChange={handleOnChange}
            onBeforeAdd={handleOnBeforeAdd}
            error={invalid}
            helperText={invalid ? 'Email incorrect' : ''}
            blurBehavior="add"
            label="Email(s)"
            classes={{
              inputRoot: classes.inputRoot,
              input: classes.input,
            }}
            fullWidth
          />
          <div style={{ marginTop: 10 }}>
            <TextField
              id="outlined-basic"
              type="text"
              name="fact"
              label="Commentaire"
              multiline
              rows={4}
              variant="outlined"
              rowsMax={15}
              fullWidth
              value={comments}
              onChange={(e) => handleOnChangeComment(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <SubmitBtn
            title="Partager"
            disabled={!emails.length || submitting}
            variant="contained"
            onClick={handleOnShare}
            color="primary"
            isSubmitting={submitting}
          />

          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Share;
